import React from 'react';
import {SurveyFormInputEnhance} from "./Inputs/SurveyFormInputEnhance";
import {useStandardizedOptions} from "../../../../../monitoring/src/Hooks/SharedSurveyHooks";
import {buildAnswer} from "../../../Hooks/SurveyFormHooks";

/**
 * This component allows us to use Survey Components that were designed
 * for the Monitoring App inside the SBA Survey viewer by mapping
 * the appropriate interfaces together.
 * @param Component
 * @returns {function(*): *}
 * @private
 */
const _SurveyFormInputTranslator = (Component) => ((props) => {

    /**
     * @var Question SurveyQuestion
     * @var Answer Answer
     */
    const {
        SurveyTypeId,
        ConservationAction,
        Question,
        Validation,
        Answer,
        OnChange,
        OnConservationActionChange,
        OnValidation,
        EditMode,
        children,
    } = props;

    const optionItems = useStandardizedOptions(Question.options);
    const value = Answer?.valueText ?? null;

    const onChange = (newValue) => {
        void OnChange(buildAnswer(Question, ConservationAction, Answer, {
            valueText: newValue !== undefined ? newValue : value,
        }));
    }

    return <Component
        code={Question.code}
        options={optionItems}
        value={value}
        readOnly={!EditMode}
        onChange={onChange}
    >
        {children}
    </Component>;
});

export const SurveyFormInputTranslator = (component) => SurveyFormInputEnhance(_SurveyFormInputTranslator(component));


